/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MentorsQueryVariables = Types.Exact<{
  where: Types.EventAttendeeWhereInput;
}>;

export type MentorsQuery = {
  eventAttendees: Array<
    Pick<Types.EventAttendee, "id"> & {
      user: Pick<Types.User, "id" | "name" | "email">;
      shift_signup?: Types.Maybe<
        Array<
          Pick<Types.ShiftSignup, "checked_in"> & {
            shift: Pick<
              Types.EventActivity,
              "name" | "start_time" | "end_time" | "category"
            >;
          }
        >
      >;
    }
  >;
};

export const MentorsDocument = gql`
  query Mentors($where: EventAttendeeWhereInput!) {
    eventAttendees(
      where: {
        AND: [
          { role: { equals: "mentor" } }
          { event: { is: { slug: { equals: "hackthenorth2025" } } } }
          $where
        ]
      }
    ) {
      id
      user {
        id
        name
        email
      }
      shift_signup {
        checked_in
        shift {
          name
          start_time
          end_time
          category
        }
      }
    }
  }
`;

/**
 * __useMentorsQuery__
 *
 * To run a query within a React component, call `useMentorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMentorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MentorsQuery,
    MentorsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<MentorsQuery, MentorsQueryVariables>(
    MentorsDocument,
    baseOptions
  );
}
export function useMentorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MentorsQuery,
    MentorsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<MentorsQuery, MentorsQueryVariables>(
    MentorsDocument,
    baseOptions
  );
}
export type MentorsQueryHookResult = ReturnType<typeof useMentorsQuery>;
export type MentorsLazyQueryHookResult = ReturnType<typeof useMentorsLazyQuery>;
export type MentorsQueryResult = ApolloReactCommon.QueryResult<
  MentorsQuery,
  MentorsQueryVariables
>;
